import { plans } from '@thecompaniesapi/shared/client'

export default function useSubscription() {
  const billingStore = useBillingStore()
  const config = useRuntimeConfig()
  const guards = useGuards()
  const localePath = useLocalePath()
  const router = useRouter()
  const teamsStore = useTeamsStore()
  const userStore = useUserStore()

  const loadingCheckoutSession = ref<string>()
  const loadingPortal = ref(false)

  const checkAvailableCredits = () => {
    let hasAvailableCredits = true

    // Make sure the user is autheticated
    if (!userStore.user) {
      router.push(localePath('auth-login'))
    }
    // Buy more credits if needed
    else if (typeof teamsStore.currentTeam?.credits === 'number' && teamsStore.currentTeam?.credits <= 0) {
      hasAvailableCredits = false

      router.push(localePath('settings-subscription'))
    }

    return hasAvailableCredits
  }

  async function openCheckoutSession(planName: PlanName, paymentInterval: 'monthly' | 'yearly' = 'monthly') {
    if (guards.userOnly()) {
      const environment = config.public.nuxtEnv === 'production' ? 'production' : 'development'
      const planForEnv = plans[planName][environment]

      if (planForEnv) {
        loadingCheckoutSession.value = planName

        const planId = planForEnv.usd[paymentInterval]
        const checkoutSessionUrl = await billingStore.createSubscription(planId)

        loadingCheckoutSession.value = undefined

        if (checkoutSessionUrl) {
          window.open(checkoutSessionUrl, '_blank')
        }
      }
    }
  }

  async function openPortal() {
    loadingPortal.value = true

    try {
      await billingStore.fetchPortal()

      if (billingStore.portal && billingStore.portal.url) {
        window.open(billingStore.portal.url, '_blank')
      }
    }
    catch (error) {
      console.error(error)
    }

    loadingPortal.value = false
  }

  return {
    checkAvailableCredits,
    loadingCheckoutSession,
    loadingPortal,
    openCheckoutSession,
    openPortal,
  }
}
